import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

class Lightbox extends Component {
  static propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    children: PropTypes.node,
    backdrop: PropTypes.bool,
    active: PropTypes.bool,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    size: 'medium',
    backdrop: false,
    active: false,
    onClose: () => console.log('onClose'),
    children: null,
  }

  constructor(props) {
    super(props)

    this.$ = {
      content: null,
    }
  }

  componentDidUpdate({ active }) {
    if (!active && this.props.active) {
      this.disableScroll()
    } else if (active && !this.props.active) {
      this.enableScroll()
    }
  }

  componentWillUnmount() {
    this.enableScroll()
  }

  onClose = e => {
    if (e.target !== this.$.content && !this.$.content.contains(e.target)) {
      this.props.onClose()
    }
  }

  getClassName() {
    return classnames(
      styles.root,
      styles[this.props.size],
      {
        [styles.backdrop]: this.props.backdrop,
        [styles.active]: this.props.active,
      },
      this.props.className,
    )
  }

  enableScroll = () => {
    document.documentElement.style.overflow = 'auto'
  }

  disableScroll = () => {
    document.documentElement.style.overflow = 'hidden'
  }

  render() {
    return (
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        className={this.getClassName()}
        onClick={this.onClose}
      >
        <div
          className={styles.content}
          ref={node => {
            this.$.content = node
          }}
        >
          <button
            className={styles.close}
            type="button"
            onClick={this.props.onClose}
          >
            <span>Close</span>

            <svg viewBox="0 0 100 100">
              <polygon points="100 13.783 86.217 0 50.015 36.202 13.783 0 0 13.783 36.202 50.015 0 86.217 13.783 100 50.015 63.798 86.217 100 100 86.217 63.798 50.015 100 13.783" />
            </svg>
          </button>

          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Lightbox



// WEBPACK FOOTER //
// ../source/components/Lightbox/index.js